var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isStatusConfigured ? _c('font-awesome-icon', {
    class: `text-${_vm.variant}`,
    style: {
      'color': _vm.color
    },
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }